(() => {
  // PitchPrint's legacy placement dropdown does not recognize Horizon radios.
  const syncPlacement = () => {
    const select = document.getElementById('pp_design_select');
    if (!select || typeof select.onchange !== 'function') return;
    const placement = document.querySelector('input[data-option-name="Graphic Placement"]:checked, select[name="options[Graphic Placement]"]');
    if (!placement) return;
    const option = Array.from(select.options).find(option => option.text.trim() === placement.value);
    if (!option || select.value === option.value) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('change', syncPlacement);
  new MutationObserver(syncPlacement).observe(document.body, { childList: true, subtree: true });
  syncPlacement();
})();
